export enum ReportPermission {
  DivisionRead = 'report.division.read',
}

export enum AdminPermission {
  DivisionRead = 'administration.division.read',
  DivisionUpdate = 'administration.division.update',
}

export enum SystemPermission {
  SuperAdmin = 'superAdmin',
  Admin = 'admin',
}

export enum CatalogPermission {
  DivisionCreate = 'catalog.division.create',
  DivisionRead = 'catalog.division.read',
  DivisionUpdate = 'catalog.division.update',
  DivisionDelete = 'catalog.division.delete',
}

export type Permission =
  | SystemPermission
  | CatalogPermission
  | ReportPermission
  | AdminPermission;
